// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Ics7","title":"Info_title__1HNws","links":"Info_links__1-t6v","link":"Info_link__34kFR","logo":"Info_logo__2CbxA"};